import { render, staticRenderFns } from "./PokemonNameGen.vue?vue&type=template&id=f9fad9ca&scoped=true&"
import script from "./PokemonNameGen.vue?vue&type=script&lang=js&"
export * from "./PokemonNameGen.vue?vue&type=script&lang=js&"
import style0 from "./PokemonNameGen.vue?vue&type=style&index=0&id=f9fad9ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fad9ca",
  null
  
)

export default component.exports